<template>
  <main class="rate-fraud-free-content">
    <RateFraudFreeBanner
      :cash-reward="cashReward"
      class="mb-4"
    />

    <div
      class="d-flex flex-column gr-8"
      :class="{ 'px-2': isMobile }"
    >
      <section class="rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3">
        <h2 class="text-h6">
          {{ t('О программе', options) }}
        </h2>

        <p>
          {{ t('На сайте ПроДокторов участились случаи публикации ложных отзывов.', options) }}
          <!-- eslint-disable max-len -->
          {{ t('Некоторые клиники и врачи придумали, как обойти проверку: стали выдавать фальшивые документы, подтверждающие факт приёма, и заказывать недостоверные отзывы.', options) }}
          <!-- eslint-enable max-len -->
        </p>

        <p>
          <!-- eslint-disable max-len -->
          {{ t('Чтобы защитить пациентов, которые выбирают специалистов по отзывам на ПроДокторов, и обеспечить равные условия для врачей и клиник, мы запустили программу «Отзывы без обмана».', options) }}
          <!-- eslint-enable max-len -->
        </p>

        <p>
          <!-- eslint-disable max-len -->
          {{ t('Вы сможете получить вознаграждение до ', options) }}{{ cashReward }}, {{ t('если сообщите об опубликованном заказном отзыве и предоставите доказательства.', options) }}
          {{ t('Портал применит санкции к клиникам и врачам, которые решили обмануть пациентов.', options) }}
          <!-- eslint-enable max-len -->
        </p>
      </section>

      <AlertInfo
        v-if="context.request.country.is_russia"
        class="mt-n4"
      >
        <div class="text-body-2 text--text">
          {{ t('Уже раскрыли более 30 врачей и клиник, которые заказывали отзывы', options) }}
        </div>
        <v-btn
          small
          :href="reverseFull({ name: 'shame_mark' })"
          color="primary"
          elevation="0"
          class="mt-2"
        >
          {{ t('Смотреть список', options) }}
        </v-btn>
      </AlertInfo>

      <section class="rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3">
        <h2 class="text-h6">
          {{ t('Сообщите о заказном отзыве, если вы', options) }}
        </h2>

        <ol>
          <li>
            {{ t('Физическое лицо, достигшее 18-летнего возраста.', options) }}
            {{ t('И получили заказ от клиники или врача на написание недостоверного отзыва на ПроДокторов.', options) }}
          </li>
          <li>
            <!-- eslint-disable max-len -->
            {{ t('Клиника или врач.', options) }} {{ t('И добровольно признаетесь, что заказывали написание и публикацию отзывов на ПроДокторов.', options) }}
            <!-- eslint-enable max-len -->
          </li>
        </ol>
      </section>

      <section class="rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3">
        <h2 class="text-h6">
          {{ t('Как сообщить о заказном отзыве', options) }}
        </h2>

        <ol>
          <li>
            <p class="mb-2">
              {{ t('Напишите на электронную почту', options) }} <a
                class="primary--text link-decoration-underline"
                href="mailto:proverka@medrocket.ru"
              >proverka@medrocket.ru.</a>
              {{ t('Укажите:', options) }}
            </p>
            <ul class="d-flex flex-column gr-1">
              <li>
                {{ t('номер телефона, который использовали при оставлении отзыва', options) }}
              </li>
              <!-- eslint-disable max-len -->
              <li>
                {{ t('видеозапись переписки со ссылкой на страницу клиники или врача, ценой, содержанием отзыва', options) }}
              </li>
              <!-- eslint-enable max-len -->
              <li>
                {{ t('документ, подтверждающий получение денежных средств от заказчика', options) }}
              </li>
              <!-- eslint-disable max-len -->
              <li>
                {{ t('фальшивые документы, которые заказчик предоставил для подтверждения отзыва: чеки, договоры, медицинские заключения, выписки', options) }}
              </li>
              <!-- eslint-enable max-len -->
              <li>
                {{ t('иные документы по запросу портала ПроДокторов.', options) }}
              </li>
            </ul>
          </li>
        </ol>
      </section>

      <section class="rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3">
        <h2 class="text-h6">
          {{ t('Как получить вознаграждение', options) }}
        </h2>

        <p>
          {{ t('Специалисты портала ПроДокторов проверят доказательства в течение 5 рабочих дней.', options) }}
        </p>
        <p>
          {{ t('После этого свяжутся с вами, чтобы уточнить реквизиты для выплаты вознаграждения.', options) }}
        </p>
      </section>

      <section class="rate-fraud-free-content__section text-body-1 text--text d-flex flex-column gr-3">
        <h2 class="text-h6">
          {{ t('Санкции. Что важно знать', options) }}
        </h2>

        <div class="d-flex flex-column gr-2">
          <h3 class="text-subtitle-1">
            {{ t('Авторам заказных отзывов', options) }}
          </h3>
          <p>
            <!-- eslint-disable max-len -->
            {{ t('На портале ПроДокторов все отзывы такого пользователя будут аннулированы, а аккаунт заблокирован.', options) }}
            <!-- eslint-enable max-len -->
          </p>
        </div>

        <div class="d-flex flex-column gr-2">
          <h3 class="text-subtitle-1">
            {{ t('Заказчикам', options) }}
          </h3>
          <p>
            <!-- eslint-disable max-len -->
            {{ t('Таким клиникам и врачам ПроДокторов заблокирует любые возможности для продвижения на портале и обнулит их рейтинг.', options) }}
            {{ t('На личной странице пациенты увидят предупреждающий баннер.', options) }}
            <!-- eslint-enable max-len -->
          </p>
        </div>
      </section>

      <p class="text-body-1 text--text">
        {{ t('Подробнее читайте в', options) }} <a
          class="primary--text link-decoration-underline"
          href="/info/rate-fraud-free-rules/"
        >{{ t('Правилах программы', options) }}</a>.
        <br>
        {{ t('Если у вас остались вопросы, обратитесь по почте', options) }} <a
          class="primary--text link-decoration-underline"
          href="mailto:proverka@medrocket.ru"
        >proverka@medrocket.ru</a>
      </p>
    </div>
  </main>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import useURLStore from 'src/store/useURLStore'
import useContextStore from 'src/store/useContextStore'
import formatPrice from 'src/functions/formatPrice'
import AlertInfo from 'www/vue_components/common/core/AlertInfo/AlertInfo.vue'
import type { ContextStore } from 'src/components/pages/info/rate-fraud-free/index/types'
import RateFraudFreeBanner from 'src/components/pages/info/rate-fraud-free/index/RateFraudFreeContent/components/RateFraudFreeBanner.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()

const cashReward = `${formatPrice({ price: 5000 })} ${context.currency.symbol}`
const isMobile = context.flavour === 'mobile'
</script>

<style lang="scss" scoped>
.rate-fraud-free-content {
  &__section {
    & > ol,
    & > ul {
      display: flex;
      flex-direction: column;
      row-gap: inherit;
    }

    ol,
    ul {
      padding-left: 20px;
    }

    ul {
      list-style-type: none;
    }

    ul li::before {
      content: '\2022';
      margin-left: -14px;
    }
  }
}
</style>
